<template>
  <nav class="navbar">
    <svg class="navbar__icon" viewBox="0 0 512 512" @click="navbarExpand">
      <path
        d="M-0.97 318.93l513.94 0 0 54.09 -513.94 0 0 -54.09zm0 -179.95l513.94 0 0 54.09 -513.94 0 0 -54.09z"
      ></path>
    </svg>
    <p class="navbar__detail" :class="[homePage && 'navbar__detail--homepage']">{{ text }}</p>
    <!-- if we were in home page this svg will render into DOM -->
    <svg viewBox="0 0 1500 430" class="navbar__img" v-if="homePage">
      <g id="Layer_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <g id="_2595311732432">
          <path
            class="fil3"
            d="M185.04 325.02l173.31 -175.84c7.43,19.95 11.56,41.52 11.73,64.05l-185.04 187.74 0 -75.95zm0 -220.23l64.09 -65.03c-19.81,-7.37 -41.21,-11.41 -63.55,-11.48l-0.54 0.55 0 75.96zm0 148.09l147.99 -150.15c-10.7,-14.32 -23.4,-27.04 -37.68,-37.73l-110.31 111.92 0 75.96z"
          />
          <path
            class="fil4"
            d="M11.73 149.18l173.31 175.84 0 75.95 -185.04 -187.74c0.16,-22.53 4.29,-44.1 11.73,-64.05zm173.31 -120.35l0 75.96 -64.1 -65.03c19.81,-7.37 41.22,-11.41 63.55,-11.48l0.55 0.55zm0 148.09l0 75.96 -147.99 -150.15c10.69,-14.32 23.39,-27.04 37.67,-37.73l110.32 111.92z"
          />
        </g>
      </g>
    </svg>
    <!-- otherwise this svg will render -->
    <div class="backward" @click="$router.go(-1)" v-if="!homePage">
      <svg viewBox="0 0 512 512" class="go-back">
        <path
          d="M174.6 252.89l205.16 -205.16c7.2,-7.21 7.2,-18.89 0,-26.1 -7.2,-7.2 -18.88,-7.2 -26.09,0l-221.43 221.44c-7.2,7.2 -7.2,18.88 0,26.09l221.43 221.43c7.33,7.08 19.01,6.87 26.09,-0.46 6.91,-7.15 6.91,-18.48 0,-25.63l-205.13 -205.13 0 -0.03c-0.82,-0.83 -1.33,-1.97 -1.33,-3.23 0,-1.26 0.51,-2.4 1.33,-3.22l-0.03 0z"
        ></path>
      </svg>
    </div>
  </nav>
  <div class="expand-menu" :class="[expand && 'expand-menu--show']">
    <div class="expand__logo">
      <svg
        class="expand__logo-img"
        style="
          shape-rendering: geometricPrecision;
          text-rendering: geometricPrecision;
          image-rendering: optimizeQuality;
          fill-rule: evenodd;
          clip-rule: evenodd;
        "
        viewBox="0 0 5642.76 1620.39"
      >
        <g id="Layer_x0020_1">
          <metadata id="CorelCorpID_0Corel-Layer" />
          <path
            class="fil0v"
            d="M2642.73 168.22l0 177.68 0 113.04 0 111.69 0 4.59c0,44.89 -11.21,74.47 -33.66,88.75 -16.32,10.2 -46.92,15.3 -91.8,15.3l-132.35 0 -23.04 0 -27.28 0 -2.09 0 -228.51 0c-124.51,0 -226.38,-101.87 -226.38,-226.38l0 -58.27c0,-124.51 101.87,-226.38 226.38,-226.38l257.88 0 23.04 0 -89.32 0 2.04 0 183.53 0c-6.02,-22.5 -14.35,-40.87 -25,-55.08 -29.59,-37.74 -81.16,-56.61 -154.54,-56.61l-242.05 0 0 0.01 -0.74 -0.01 0 0c-178.93,0 -325.34,146.45 -325.34,325.33l0 83.75c0,178.89 146.41,325.34 325.34,325.34l0 0c11.1,0 22.08,-0.57 32.91,-1.67 11.38,1.11 23.42,1.67 36.13,1.67 385.72,0 129.12,0 514.85,0 73.95,0 125.47,-18.87 154.28,-56.62 25.75,-32.64 38.5,-87.2 38.5,-163.71l0 -514.09 -135.09 0c-31.71,0 -57.7,38.89 -57.7,86.42l0 25.27zm2713.33 290.71l-310.42 0c-44.86,0 -75.48,-5.1 -91.8,-15.3 -23.46,-14.28 -35.19,-43.86 -35.19,-88.74l0 -91.8c0,-39.78 11.73,-66.3 35.19,-79.56 17.34,-10.2 47.94,-15.31 91.8,-15.31l132.32 0 9.97 0 53.02 0c124.52,0 226.39,101.87 226.39,226.38l0 58.27c0,124.51 -101.87,226.38 -226.39,226.38l-53.02 0 -9.97 0 0 -1.59c-11.51,1.06 -24.5,1.59 -38.99,1.59l-302.22 0c-47.53,0 -86.41,25.99 -86.41,57.7l0 54 437.59 0 30.93 0 45.57 0c3.89,0 7.72,-0.06 11.48,-0.16 3.4,0.11 6.8,0.16 10.22,0.16l0 0c178.93,0 325.33,-146.43 325.33,-325.34l0 -83.75c0,-172.76 -136.53,-315.24 -307.04,-324.81l0 -0.52 -18.29 0 -0.75 0 -97.45 0 -269.29 0c-73.43,0 -124.95,18.87 -154.54,56.61 -24.47,32.65 -36.72,87.22 -36.72,163.72l0 73.44c0,76.5 12.24,131.07 36.72,163.72 29.59,37.74 81.1,56.61 154.54,56.61l437.41 0 0 -111.69zm-1767.64 111.69l91.86 0c-39.89,65.02 -111.66,108.63 -193.12,108.63l-53.02 0 -9.98 0 0 -1.59c-11.51,1.06 -24.5,1.59 -38.98,1.59l-302.22 0c-47.53,0 -86.42,25.99 -86.42,57.7l0 54 437.6 0 29.15 0 1.78 0 45.57 0c3.89,0 7.72,-0.06 11.48,-0.16 3.39,0.11 6.8,0.16 10.22,0.16l0 0c142.22,0 263.89,-92.52 307.83,-220.33l73.36 0 3.28 0 181.05 0 387.44 0c43.75,-7.68 75.98,-25.03 96.6,-52.03 25.76,-32.63 38.5,-87.21 38.5,-163.71l0 -298.35 -192.79 0 0 111.69 0 182.08 0 4.59c0,44.87 -11.21,74.46 -33.66,88.74 -16.32,10.2 -46.94,15.3 -91.8,15.3l-80.2 0c7.35,-28.39 11.01,-63.07 11.01,-104.05l0 -298.35 -192.78 0 0 111.69 0 182.08 0 4.59c0,44.87 -11.22,74.46 -33.66,88.74 -15.29,9.56 -43.16,14.64 -83.51,15.24l0 0.05 -6.2 0 -3.28 0 -55.85 0 -144.2 0 -125.04 0 -57.91 0 -32.85 0 -205.82 0c-44.88,0 -75.48,-5.1 -91.8,-15.3 -23.46,-14.28 -35.19,-43.86 -35.19,-88.74l0 -91.8c0,-39.78 11.73,-66.3 35.19,-79.56 17.34,-10.2 47.94,-15.31 91.8,-15.31l132.32 0 9.98 0 53.02 0c124.51,0 226.38,101.87 226.38,226.38l0 4.53 144.13 0 0 -17.27c0,-172.76 -136.54,-315.24 -307.04,-324.81l0 -0.52 -18.3 0 0 0 -0.74 0 -97.45 0 -269.29 0c-73.43,0 -124.95,18.87 -154.54,56.61 -24.48,32.65 -36.72,87.22 -36.72,163.72l0 73.44c0,76.5 12.24,131.07 36.72,163.72 29.59,37.74 81.11,56.61 154.54,56.61l332.82 0 90.76 0zm665.87 220.33l0.06 1.85 0 71.29 -83.98 0c-47.51,0 -86.43,-25.96 -86.43,-57.7l0 -15.44 -155.63 0c-47.52,0 -86.42,-25.96 -86.42,-57.7l0 -54 326.04 0c47.53,0 86.42,25.98 86.42,57.7l0 54 -0.06 0zm89.01 -111.7l256.88 0c47.53,0 86.41,25.99 86.41,57.7l0 54 -256.87 0c-47.51,0 -86.42,-25.96 -86.42,-57.7l0 -54zm-2215.57 -363.77l128 0c60.06,0 109.21,49.16 109.21,109.22l0 102.22 -127.98 0c-60.07,0 -109.24,-49.14 -109.23,-109.22l0 -102.22z"
          />
          <path
            class="fil1v"
            d="M1997.31 1423.91l-124.27 0c-12.59,0 -25.06,-1.74 -37.4,-5.23 -23.86,-7.24 -42.76,-23.8 -56.7,-49.8 -12.6,-23.52 -18.9,-51 -18.9,-82.3 0,-30.23 5.63,-57.04 16.89,-80.3 12.33,-25.74 29.89,-43.23 52.69,-52.61 17.69,-7.24 35.79,-10.86 54.28,-10.86l112.6 0 0 53.89 -117.02 0c-19.03,0 -32.84,10.32 -41.42,30.96 -6.7,16.09 -10.06,37.13 -10.06,63.14 0,21.98 4.29,40.61 12.87,55.9 9.92,17.96 23.86,26.94 41.82,26.94l114.61 0 0 50.27zm314.48 -95.17c0,36.93 -14.75,63.07 -44.24,78.29 -21.98,11.26 -53.49,16.89 -94.5,16.89 -39.94,0 -71.98,-6.57 -96.11,-19.7 -30.83,-16.56 -46.25,-42.69 -46.25,-78.28l0 -183.11 71.19 0 0 174.19c0,21.98 7.9,37.94 23.72,47.79 11.53,7.24 25.87,10.86 43.04,10.86 29.22,0 49.33,-5.77 60.32,-17.3 9.39,-9.85 14.07,-24.46 14.07,-43.7l0 -171.85 68.77 0 0 185.93zm337.4 7.7c0,24.6 -8.18,45.31 -24.53,62.2 -16.35,16.82 -37.13,25.27 -62.33,25.27l-199.06 0 0 -50.27 164.07 0c10.99,0 20.24,-2.55 27.75,-7.71 8.58,-5.9 12.87,-14.01 12.87,-24.26 0,-23.99 -16.89,-35.99 -50.67,-35.99l-82.84 0c-23.86,0 -44.77,-7.37 -62.73,-22.05 -17.96,-14.74 -26.94,-33.45 -26.94,-56.17 0,-25.14 8.78,-45.51 26.34,-61.19 17.56,-15.62 40.68,-23.46 69.37,-23.46l190.21 0 0 48.26 -167.7 0c-7.5,0 -15.08,3.15 -22.72,9.39 -7.64,6.3 -11.46,13.67 -11.46,22.18 0,9.59 3.69,17.63 11.06,24.2 7.37,6.5 16.28,9.78 26.74,9.78l91.29 0c28.42,0 50.74,7.31 66.96,21.85 16.22,14.61 24.33,33.92 24.33,57.98zm283.51 -145.78l-104.96 0 0 234.05 -65.15 0 0 -234.05 -103.35 0 0 -47.85 273.46 0 0 47.85zm322.52 92.3c0,54.76 -15.15,93.96 -45.44,117.56 -24.67,19.1 -60.59,28.62 -107.77,28.62 -52.28,0 -90.89,-10.99 -115.82,-33.04 -27.35,-24.13 -41.02,-62.94 -41.02,-116.35 0,-43.77 12.2,-77.89 36.6,-102.28 26.54,-26.61 66.22,-39.88 119.03,-39.88 58.18,0 99.2,12.73 123.06,38.27 20.91,22.52 31.37,58.24 31.37,107.11zm-71.58 -1.61c0,-27.68 -6.57,-49.73 -19.7,-66.09 -14.75,-18.3 -36.59,-27.41 -65.55,-27.41 -28.42,0 -49.86,9.78 -64.34,29.43 -12.07,16.35 -18.09,37.73 -18.09,64.07 0,30.36 4.82,52.81 14.48,67.29 13.41,20.18 38.2,30.23 74.39,30.23 30.56,0 52.01,-9.79 64.35,-29.42 9.65,-15.28 14.48,-38.01 14.48,-68.1zm457.24 142.56l-60.72 0 0 -214.75 -79.63 214.75 -72.39 0 -82.04 -219.57 0 219.57 -58.71 0 0 -281.1 94.11 0 82.44 222.39 79.22 -222.39 97.72 0 0 281.1zm296.78 0l-137.13 0c-21.18,0 -41.55,-4.82 -61.13,-14.48 -21.18,-10.39 -37.33,-27.01 -48.46,-49.8 -11.13,-22.72 -16.69,-47.79 -16.69,-75.07 0,-27.01 5.37,-51.54 16.09,-73.52 11.8,-23.8 28.15,-41.22 49.06,-52.15 11.53,-5.9 22.59,-10.05 33.18,-12.46 10.59,-2.41 22.72,-3.62 36.4,-3.62l127.07 0 0 50.27 -117.43 0c-10.46,0 -19.24,1.41 -26.34,4.16 -7.11,2.74 -14.14,7.7 -21.11,14.81 -6.97,7.11 -11.8,14.01 -14.48,20.71 -2.68,6.7 -4.02,15.08 -4.02,25.07l184.98 0 0 50.27 -184.98 0c0,9.12 1.2,17.09 3.62,23.93 2.42,6.84 6.84,13.87 13.14,21.11 6.3,7.24 12.94,12.74 19.77,16.49 6.91,3.76 15.01,5.63 24.47,5.63l123.99 0 0 48.66zm329.36 0l-79.49 0 -73.06 -109.78 -75.88 0 0 109.78 -66.76 0 0 -281.1 205.9 0c23.32,0 42.63,9.05 57.91,27.08 15.28,18.03 22.92,39.41 22.92,64.01 0,19.5 -6.57,36.06 -19.7,49.73 -13.14,13.6 -29.76,22.18 -49.87,25.67l78.02 114.61zm-89.69 -192.83c0,-13.07 -4.89,-23.13 -14.67,-30.23 -9.79,-7.04 -22.99,-10.59 -39.61,-10.59l-84.46 0 0 78.42 86.46 0c12.6,0 23.86,-2.81 33.78,-8.38 12.33,-6.97 18.49,-16.69 18.49,-29.22zm490.62 192.83l-124.26 0c-12.59,0 -25.06,-1.74 -37.4,-5.23 -23.86,-7.24 -42.76,-23.8 -56.7,-49.8 -12.6,-23.52 -18.9,-51 -18.9,-82.3 0,-30.23 5.63,-57.04 16.89,-80.3 12.33,-25.74 29.89,-43.23 52.68,-52.61 17.7,-7.24 35.79,-10.86 54.29,-10.86l112.6 0 0 53.89 -117.02 0c-19.03,0 -32.84,10.32 -41.42,30.96 -6.7,16.09 -10.06,37.13 -10.06,63.14 0,21.98 4.29,40.61 12.87,55.9 9.92,17.96 23.86,26.94 41.82,26.94l114.61 0 0 50.27zm265.82 0l-101.74 0c-29.76,0 -53.62,-3.35 -71.58,-10.05 -22.79,-8.58 -39.14,-23.26 -49.06,-44.17 -3.75,-8.04 -6.37,-15.75 -7.84,-23.06 -1.47,-7.37 -2.21,-15.89 -2.21,-25.54l0 -178.28 72.39 0 0 175.8c0,8.04 0.94,15.08 2.81,21.11 1.88,6.03 5.23,12 10.06,17.9 6.7,8.51 14.48,14.14 23.33,16.82 8.85,2.68 20.11,4.02 33.78,4.02l90.08 0 0 45.44zm315.69 -95.17c0,36.93 -14.75,63.07 -44.24,78.29 -21.98,11.26 -53.48,16.89 -94.5,16.89 -39.95,0 -71.98,-6.57 -96.11,-19.7 -30.83,-16.56 -46.25,-42.69 -46.25,-78.28l0 -183.11 71.18 0 0 174.19c0,21.98 7.91,37.94 23.72,47.79 11.53,7.24 25.87,10.86 43.03,10.86 29.22,0 49.33,-5.77 60.32,-17.3 9.38,-9.85 14.07,-24.46 14.07,-43.7l0 -171.85 68.77 0 0 185.93zm300.4 19.17c0,21.18 -7.51,39.15 -22.52,53.89 -15.02,14.75 -33.11,22.12 -54.29,22.12l-182.57 0 0 -281.1 175.34 0c20.64,0 38.54,6.03 53.69,18.09 15.15,12.06 23.79,27.88 25.94,47.46 0.27,1.61 0.4,3.22 0.4,4.82 0,1.61 0,3.22 0,4.83 0,15.02 -3.62,28.22 -10.86,39.61 -7.24,11.39 -18.09,20.31 -32.57,26.74 14.74,5.36 26.34,13.54 34.79,24.53 8.44,10.99 12.67,23.99 12.67,39zm-76.41 -116.62c0,-9.65 -3.02,-17.96 -9.05,-24.93 -6.03,-6.97 -13.74,-10.46 -23.12,-10.46l-88.87 0 0 67.16 92.49 0.4c8.31,0 15.15,-3.15 20.51,-9.45 5.37,-6.3 8.05,-13.87 8.05,-22.72zm3.62 113.81c0,-9.39 -2.95,-17.5 -8.85,-24.33 -5.9,-6.83 -13.41,-10.26 -22.52,-10.26l-94.9 0 0 65.55 96.91 0c8.58,0 15.61,-3.02 21.11,-9.05 5.5,-6.03 8.24,-13.33 8.24,-21.91z"
          />
          <polygon
            class="fil2v"
            points="1568.81,-51.38 1599.93,-51.38 1599.93,1549.85 1568.81,1549.85 "
          />
          <path
            class="fil3v"
            d="M723.31 1159.59l644.25 -653.65c27.63,74.17 42.99,154.37 43.6,238.11l-687.85 697.89 0 -282.35zm0 -818.65l238.26 -241.74c-73.63,-27.38 -153.2,-42.43 -236.23,-42.67l-2.03 2.06 0 282.35zm0 550.51l550.13 -558.16c-39.75,-53.24 -86.96,-100.52 -140.04,-140.27l-410.09 416.07 0 282.36z"
          />
          <path
            class="fil4v"
            d="M79.06 505.94l644.25 653.65 0 282.35 -687.85 -697.89c0.61,-83.74 15.97,-163.94 43.6,-238.11zm644.25 -447.36l0 282.35 -238.26 -241.74c73.63,-27.38 153.2,-42.43 236.23,-42.67l2.03 2.06zm0 550.5l0 282.36 -550.13 -558.16c39.75,-53.24 86.96,-100.52 140.04,-140.27l410.09 416.07z"
          />
        </g>
      </svg>
    </div>
    <router-link :to="{ name: 'Scores' }" class="expand__scores">
      <div class="expand__score-circle">
        <i class="expand__score-shadow"></i>
        <p class="expand__score-text">امتیاز شما</p>
        <p class="expand__score-day eng-num">0</p>
      </div>
      <div class="expand__score-rules">
        <svg viewBox="0 0 512 512" class="score-rules--svg">
          <path
            d="m368 272h-224c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h224c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
          ></path>
          <path
            d="m256 384c-8.832031 0-16-7.167969-16-16v-224c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v224c0 8.832031-7.167969 16-16 16zm0 0"
          ></path>
        </svg>
        <p>قوانین امتیاز</p>
      </div>
    </router-link>
    <div class="expand-items">
      <router-link :to="{ name: 'EditProfile' }" class="expand-item">
        <svg
          viewBox="0 0 700 512"
          class="expand-item--svg"
          style="
            shape-rendering: geometricprecision;
            text-rendering: geometricprecision;
            fill-rule: evenodd;
            clip-rule: evenodd;
          "
        >
          <path
            d="M280.61 323.84l88.84 7.08 215.06 -215.07c26.39,-26.41 26.39,-69.65 0,-96.05 -26.41,-26.4 -69.65,-26.4 -96.06,0l-215.06 215.06 7.22 88.98 0 0zm27.79 -27.83l-4.04 -49.77 205.26 -205.27c14.71,-14.72 39,-14.72 53.71,0 14.73,14.71 14.73,38.99 0,53.71l-205.29 205.29 -49.64 -3.96zm276.28 -109.16l-24.71 24.71c3.85,16.47 5.76,33.33 5.76,50.24 0,121.41 -98.41,219.83 -219.83,219.83 -121.41,0 -219.84,-98.42 -219.84,-219.83 0,-121.41 98.43,-219.84 219.84,-219.84 15,0 29.96,1.53 44.65,4.56l25.06 -25.07c-22.65,-6.55 -46.09,-9.85 -69.71,-9.85 -138.18,0 -250.2,112.01 -250.2,250.2 0,138.18 112.02,250.2 250.2,250.2 138.18,0 250.21,-112.01 250.21,-250.2 0,-25.45 -3.83,-50.7 -11.43,-74.95l0 0z"
          ></path>
        </svg>
        <p>پروفایل</p>
      </router-link>
      <router-link :to="{ name: 'Home' }" class="expand-item">
        <svg viewBox="0 0 700 512" class="expand-item--svg">
          <path
            d="M57.73 111.01l-0.04 0.09c-0.11,0.23 -0.22,0.46 -0.31,0.68l-0.02 0.04c-0.02,0.07 -0.04,0.13 -0.06,0.18 -0.17,0.46 -0.32,0.93 -0.45,1.4 -0.04,0.17 -0.08,0.33 -0.13,0.55 -0.05,0.17 -0.07,0.35 -0.1,0.49 -0.04,0.21 -0.07,0.43 -0.1,0.69 -0.02,0.14 -0.04,0.29 -0.05,0.48 -0.04,0.37 -0.02,0.75 -0.03,1.09 0,0.07 0.02,0.15 0.03,0.21l0.02 0.08 0 52.32c0,21.07 17.07,38.69 38.26,38.69l3.03 0 0 290.75c-0.19,7.12 5.53,13.06 12.69,13.24 0.08,0.01 0.16,0.01 0.24,0.01l477.93 0c7.39,0 13.47,-5.85 13.63,-13.24l0 -290.76 3.03 0c21.19,0 38.25,-17.62 38.25,-38.69l0 -52.59c0.02,-0.51 -0.01,-1.03 -0.07,-1.57l-0.01 -0.08c0,-0.06 0,-0.14 -0.02,-0.27 -0.06,-0.47 -0.15,-0.93 -0.26,-1.34 -0.03,-0.11 -0.04,-0.2 -0.06,-0.28 -0.31,-1.08 -0.72,-2.08 -1.27,-3.03 -0.04,-0.05 -0.05,-0.09 -0.08,-0.14l-53.87 -91.19c-6.89,-11.66 -19.45,-18.82 -33,-18.82l-399.89 0c-12.52,0 -24.27,6.11 -31.43,16.37l-64.73 92.74c-0.18,0.26 -0.34,0.49 -0.48,0.72 -0.04,0.07 -0.07,0.11 -0.12,0.21l-0.03 0.05c-0.14,0.24 -0.28,0.48 -0.4,0.72 -0.04,0.08 -0.07,0.14 -0.1,0.2zm37.52 -7.18l50.16 -72.04c2.21,-3.16 5.77,-5.11 9.65,-5.18l399.88 0c4.15,0.07 7.95,2.36 10.05,5.93l42.01 71.29 -511.75 0zm311.52 381.55l-113.5 0 0 -168.54 113.5 0 0 168.54zm168.88 0l-142.26 0 0 -181.69c-0.22,-7.47 -6.26,-13.46 -13.76,-13.46l-139.89 0c-7.3,0.08 -13.16,6.04 -13.08,13.35l0.01 181.8 -142.28 0 0 -277.38 451.26 0 0 277.38zm41.29 -354.93l0 38.86c0,6.53 -5.13,11.9 -11.7,12.08l-510.54 0.01c-6.52,-0.18 -11.59,-5.61 -11.59,-12.09l0 -38.86 533.83 0zm-385.76 164.78l-78.81 0c-7.35,0 -13.31,5.96 -13.31,13.31l0 73.81c0,7.35 5.97,13.3 13.31,13.3l78.81 0c7.35,0 13.3,-5.95 13.3,-13.3l0 -73.81c0,-7.35 -5.95,-13.31 -13.3,-13.31zm-13.31 73.81l-52.2 0 0 -47.19 52.2 0 0 47.19zm328.56 -73.81l-78.81 0c-7.36,0 -13.31,5.96 -13.31,13.31l0 73.81c0,7.35 5.96,13.3 13.31,13.3l78.81 0c7.35,0 13.3,-5.95 13.3,-13.3l0 -73.81c0,-7.35 -5.95,-13.31 -13.3,-13.31zm-13.3 73.81l-52.21 0 0 -47.19 52.21 0 0 47.19z"
          ></path>
        </svg>
        <p>فروشگاه</p>
      </router-link>
      <router-link :to="{ name: 'Rules' }" class="expand-item">
        <svg viewBox="0 0 700 512" class="expand-item--svg">
          <path
            d="M415.07 283.49l0 2.65c0,40.65 33.07,73.72 73.71,73.72l30.22 0c40.64,0 73.71,-33.07 73.71,-73.72l0 -2.65 -68.89 -165.34 19.34 0 6.06 0c7.3,0 13.28,-5.97 13.28,-13.28l0 0c0,-7.31 -5.98,-13.29 -13.28,-13.29l-59.22 0 -0.09 0 -111.76 0 -0.43 -1.21c-4.38,-12.34 -14.17,-22.14 -26.51,-26.51l-1.21 -0.43 0 -42.66 0 0 0 -7.55c0,-7.31 -5.98,-13.29 -13.29,-13.29l0 0c-7.31,0 -13.28,5.98 -13.28,13.29l0 7.55 -0.01 0 0 42.66 -1.21 0.43c-12.34,4.37 -22.13,14.17 -26.51,26.51l-0.43 1.21 -111.76 0 -0.09 0 -59.22 0c-7.3,0 -13.28,5.98 -13.28,13.29l0 0c0,7.31 5.98,13.28 13.28,13.28l6.06 0 19.34 0 -68.89 165.34 0 2.65c0,40.65 33.07,73.72 73.71,73.72l30.22 0c40.64,0 73.71,-33.07 73.71,-73.72l0 -2.65 -68.88 -165.34 105.8 0 0.43 1.21c4.38,12.34 14.17,22.14 26.51,26.51l1.21 0.43 0 219.39 -1.45 0.3c-29.3,5.97 -52.26,29.35 -57.72,58.74l-0.23 1.23 -1.22 0.23c-34.8,6.46 -60.23,37 -60.23,72.45l0 13.29 268.28 0 0 -13.29c0,-35.45 -25.43,-65.99 -60.23,-72.45l-1.22 -0.23 -0.23 -1.23c-5.46,-29.39 -28.43,-52.78 -57.72,-58.75l-1.45 -0.29 0 -219.39 1.21 -0.43c12.34,-4.37 22.13,-14.17 26.51,-26.51l0.43 -1.21 105.8 0 -68.88 165.34 0 0zm-245.54 -144.07l55.6 133.43 -111.2 0.01 55.6 -133.44 0 0zm15.11 193.86l-30.22 0c-19.98,0 -37.78,-12.66 -44.43,-31.43l-0.86 -2.43 120.8 0 -0.86 2.43c-6.65,18.77 -24.45,31.43 -44.43,31.43l0 0zm319.25 -193.86l55.6 133.43 -111.2 0.01 55.6 -133.44 0 0zm15.11 193.86l-30.22 0c-19.98,0 -37.78,-12.66 -44.43,-31.43l-0.86 -2.43 120.8 0 -0.86 2.43c-6.65,18.77 -24.45,31.43 -44.43,31.43l0 0zm-76.56 152.07l-211.46 0 0.86 -2.42c6.65,-18.77 24.47,-31.43 44.44,-31.43l120.86 0c19.97,0 37.78,12.66 44.44,31.43l0.86 2.42 0 0zm-60.44 -60.42l-90.58 0 0.86 -2.43c6.65,-18.77 24.46,-31.42 44.43,-31.42 19.98,0 37.78,12.65 44.43,31.42l0.86 2.43 0 0zm-45.29 -303.14c-9.33,0 -16.92,-7.59 -16.92,-16.92 0,-9.34 7.59,-16.93 16.92,-16.93 9.33,0 16.92,7.59 16.92,16.93 0,9.33 -7.59,16.92 -16.92,16.92z"
          ></path>
        </svg>
        <p>قوانین</p>
      </router-link>
      <div class="expand-item">
        <svg viewBox="0 0 700 512" class="expand-item--svg">
          <path
            d="M94 512l512 0 0 -53.42c0,-23.16 -14.78,-43.56 -36.78,-50.77l-136.24 -44.66 0 -48.52 0.33 -0.48c9.77,-14.44 15.92,-31.02 18.11,-48.31l0.21 -1.68 26.04 0c20.21,0 36.65,-16.44 36.65,-36.65l0 -41.31c0,-7.39 -2.21,-14.54 -6.38,-20.64l-0.34 -0.49 0 -7.47c0,-86.9 -70.7,-157.6 -157.6,-157.6 -86.9,0 -157.6,70.7 -157.6,157.6l0 7.47 -0.34 0.49c-4.17,6.1 -6.38,13.25 -6.38,20.64l0 41.31c0,20.21 16.44,36.65 36.65,36.65l26.04 0 0.21 1.68c2.22,17.52 8.51,34.31 18.51,48.89l0.34 0.49 0 47.8 -136.65 44.79c-22,7.21 -36.78,27.61 -36.78,50.77l0 53.42 0 0zm202.78 -168.27c15.93,10.29 34.23,15.81 53.22,15.81 19.15,0 37.6,-5.61 53.62,-16.07l2.96 -1.93 0 25.26 -0.66 0.58c-14.11,12.15 -36.68,26.69 -55.92,26.69 -19.18,0 -41.53,-14.47 -55.52,-26.65l-0.65 -0.57 0 -25.02 2.95 1.9 0 0zm86.76 -213.28l-26.47 0c-1.01,25.97 -22.45,46.78 -48.66,46.78l-34.34 0.01 0 -16.48c0,-41.87 34.06,-75.93 75.93,-75.93 41.87,0 75.93,34.06 75.93,75.93l0 16.11 -2.25 -0.4c-22.54,-4 -39.24,-23.28 -40.14,-46.02zm-14.28 140.23l0 26.39 43.79 0 -2.07 3c-13.95,20.21 -36.2,33.07 -60.98,33.07 -44.03,0 -75.93,-39.07 -75.93,-81.67l0 -47.84 34.34 0c23.89,0 46.17,-11.32 60.36,-30.46l1.54 -2.08 1.54 2.08c12.5,16.86 31.45,27.82 52.36,30.04l1.72 0.18 0 48.08c0,5.94 -0.62,11.86 -1.82,17.68l-0.31 1.53 -54.54 0 0 0zm118.66 -43.17c0,5.66 -4.6,10.25 -10.25,10.25l-25.35 0 0 -61.82 25.35 0c5.65,0 10.25,4.61 10.25,10.26l0 41.31zm-137.92 -201.11c68.42,0 125.62,52.93 130.82,121.12l0.16 2.13 -2.13 -0.07c-0.39,-0.01 -0.79,-0.03 -1.18,-0.03l-25.94 0 -0.22 -1.68c-6.43,-50.98 -50.08,-89.44 -101.51,-89.44 -51.43,0 -95.08,38.46 -101.52,89.44l-0.21 1.68 -25.94 0c-0.39,0 -0.79,0.02 -1.19,0.03l-2.13 0.07 0.17 -2.13c5.2,-68.19 62.4,-121.12 130.82,-121.12l0 0zm-137.92 201.11l0 -41.31c0,-5.65 4.6,-10.26 10.25,-10.26l25.35 0 0 61.82 -25.35 0c-5.65,0 -10.25,-4.6 -10.25,-10.25zm289.86 226.86l-26.4 0 0 31.23 -251.09 0 0 -31.23 -26.39 0 0 31.23 -77.66 0 0 -27.02c0,-11.71 7.48,-22.04 18.6,-25.69l138.42 -45.37 0.81 0.7c19.18,16.35 45.93,32.24 71.77,32.24 25.84,0 52.75,-15.9 72.02,-32.17l0.82 -0.68 138.15 45.28c11.13,3.65 18.61,13.98 18.61,25.69l0 27.02 -77.66 0 0 -31.23 0 0z"
          ></path>
        </svg>
        <p>پشتیبانی</p>
      </div>
      <router-link :to="{ name: 'About' }" class="expand-item">
        <svg class="expand-item--svg" viewBox="0 0 700 512">
          <path
            d="M350 283.09l179.22 -181.84c-8.15,-9.58 -17.05,-18.51 -26.61,-26.68l-152.61 154.83 -152.61 -154.83c-9.56,8.17 -18.46,17.1 -26.61,26.68l179.22 181.84zm-229.31 -83.37c-3.71,15.44 -5.86,31.23 -6.45,47.14l235.76 239.2 235.76 -239.2c-0.59,-15.91 -2.74,-31.7 -6.45,-47.14l-229.31 232.66 -229.31 -232.66zm229.31 -119.61l54.66 -55.46c-35.59,-8.31 -73.73,-8.31 -109.31,0l54.65 55.46z"
          ></path>
        </svg>
        <p>درباره ویپون</p>
      </router-link>
      <div class="expand-item">
        <svg viewBox="0 0 512 512" class="expand-item--svg">
          <path
            d="m416.303 242.244-72.456-72.457v-124.787c0-24.813-20.187-45-45-45h-196c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h306c7.146 0 13.299-5.04 14.706-12.046l27.953-139.147c8.732-43.466-4.428-87.788-35.203-118.563zm-313.456-212.244h196c8.271 0 15 6.729 15 15v193.479c-18.398-18.146-47.955-18.046-66.228.226-18.311 18.281-18.399 47.958-.122 66.359l57.456 59.733c-12.456 9.296-28.592 25.521-40.18 52.203h-176.926v-372c0-8.271 6.728-15 15-15zm-15 437v-20h167.229c-2.378 10.518-4.06 22.148-4.801 35h-147.428c-8.272 0-15-6.729-15-15zm334.247-112.102-25.533 127.102c-24.121 0-91.451 0-116.216 0 2.163-31.861 11.334-58.562 26.846-77.835 12.86-15.979 25.954-21.708 26.997-22.146 9.815-3.513 13.323-16.253 5.47-24.417-70.924-73.736-70.706-73.512-70.834-73.638-6.588-6.588-6.692-17.355 0-24.037 6.613-6.612 17.362-6.63 23.997-.049 31.711 32.436 16.291 16.871 71.785 72.364 5.857 5.858 15.355 5.859 21.213 0 5.858-5.858 5.858-15.355 0-21.213l-41.972-41.971v-56.844l51.243 51.243c23.658 23.658 33.754 57.842 27.004 91.441z"
          ></path>
        </svg>
        <p>تماس با ویپون</p>
      </div>
    </div>
    <div class="log-out" @click="logOutUser">
      <svg viewBox="0 0 700 512" class="expand-item--svg">
        <path
          d="M418.67 33.69c-9.04,-2.64 -18.53,2.55 -21.17,11.59 -2.66,9.04 2.54,18.53 11.58,21.17 86.77,25.4 150.84,105.67 150.84,201.5 0,115.75 -94.17,209.91 -209.92,209.91 -115.75,0 -209.92,-94.16 -209.92,-209.91 0,-95.63 63.88,-176.04 150.84,-201.5 9.04,-2.64 14.22,-12.13 11.58,-21.17 -2.65,-9.04 -12.13,-14.23 -21.17,-11.59 -100.05,29.29 -175.38,121.98 -175.38,234.26 0,134.89 109.15,244.05 244.05,244.05 134.89,0 244.05,-109.15 244.05,-244.05 0,-111.55 -74.61,-204.76 -175.38,-234.26zm-68.67 -33.69c-9.43,0 -17.07,7.64 -17.07,17.07l0 161.05c0,9.43 7.64,17.07 17.07,17.07 9.43,0 17.07,-7.64 17.07,-17.07l0 -161.05c0,-9.43 -7.64,-17.07 -17.07,-17.07z"
        ></path>
      </svg>
      <p>خروج</p>
    </div>
    <p class="rights eng-num">VIPON © 2021</p>
  </div>
  <div class="backdrop" v-if="expand" @click.self="expand = false"></div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      expand: false,
      homePage: null,
    };
  },
  methods: {
    navbarExpand() {
      this.expand = true;
    },
    logOutUser() {
      this.$store.dispatch("clearUser");
    },
  },
  props: ["text"],
  mounted() {
    if (this.$route.name !== "Home") {
      this.homePage = false;
    } else {
      this.homePage = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  z-index: 101;
  right: 0;
  left: 0;
  border-radius: 0;
  top: 0;
  padding: 0px 2%;
  width: 100%;
  height: 60px;
  background: linear-gradient(180deg, #000 0, transparent);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.navbar__img {
  width: 110px;
  height: 50px;
}
/* svg styles */
.fil0 {
  fill: #fefefe;
}
.fil4 {
  fill: #8f6d28;
}
.fil2 {
  fill: #999999;
}
.fil3 {
  fill: #cc9933;
}
.fil1 {
  fill: gray;
  fill-rule: nonzero;
}
.navbar__icon {
  fill: #a8a8a8;
  width: 30px;
  height: 50px;
  cursor: pointer;
}
// navbar expand => sidebar Menu
.expand-menu {
  position: fixed;
  overflow: hidden;
  top: 0;
  bottom: 0;
  right: 0;
  height: 100vh;
  width: 70%;
  z-index: 400;
  transform: translateX(300%);
  transition: all 0.4s ease;
  background: linear-gradient(180deg, #fff 150px, #eee 250px);
  border-radius: 40px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0;
}
.expand-menu--show {
  transform: translateX(0%);
}
// navbar menu logo ==> svg classes
.fil0v {
  fill: black;
}
.fil4v {
  fill: #8f6d28;
}
.fil2v {
  fill: #999999;
}
.fil3v {
  fill: #cc9933;
}
.fil1v {
  fill: gray;
  fill-rule: nonzero;
}
// ended
.expand__logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.expand__logo-img {
  width: 110px;
  height: 35px;
}
.expand__scores {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.expand__score-circle {
  position: relative;
  z-index: auto;
  height: 130px;
  width: 130px;
  border-radius: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  overflow: visible;
}
.expand__score-shadow {
  width: 100%;
  z-index: -1;
  height: 100%;
  background-color: #c69d4e;
  position: absolute;
  border-radius: 100%;
  -webkit-animation: shadow 1.3s infinite;
  animation: shadow 1.3s infinite;
}
.expand__score-text {
  z-index: 2;
  margin-bottom: 5px;
  color: #000;
}
.expand__score-day {
  z-index: 2;
  margin: 0;
  padding-bottom: 0;
  color: #c69d4e;
  font-size: 25px;
  font-weight: 700;
  -webkit-animation: blink 1.3s infinite;
  animation: blink 1.3s infinite;
}
@keyframes shadow {
  0% {
    transform: scale(1);
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
}
@keyframes blink {
  0% {
    opacity: 1;
    color: #c69d4e;
  }
  100% {
    opacity: 0.2;
    color: #777;
  }
}
.expand__score-rules {
  z-index: -2;
  text-align: center;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 12px);
  height: 60px;
  border-radius: 10px;
  color: #000;
}
.score-rules--svg {
  fill: #c69d4e;
  width: 30px;
  height: 30px;
}
.expand-items {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: 6px;
  padding: 0 6px;
  margin: 8px 0;
}
.expand-item {
  background-color: #fff;
  height: 100px;
  display: flex;
  border-radius: 15px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  p {
    font-size: 13px;
    color: #000;
  }
}
.expand-item--svg {
  fill: #c69d4e;
  width: 34px;
  height: 34px;
  margin-bottom: 5px;
}
.log-out {
  z-index: 2;
  text-align: center;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 12px);
  height: 50px;
  border-radius: 10px;
  color: #fff;
  padding: 10px 0;
  cursor: pointer;
}
.rights {
  font-size: 12px;
  direction: ltr;
  width: 100%;
  padding: 0 5px;
  text-align: center;
  margin-top: 10px;
  color: #777;
}
.backdrop {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 250;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.navbar__detail {
  color: #eee;
}
.navbar__detail--homepage{
  margin-right: 70px;
}
.backward{
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.go-back{
  fill: #a8a8a8;
}
</style>